// Polyfill for URL.parse() - required by pdfjs-dist for older browsers/Safari
// URL.parse() was added to browsers in 2024 and isn't universally supported yet
if (typeof URL.parse !== 'function') {
  (URL as any).parse = function(url: string, base?: string): URL | null {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installConsoleCapture } from "./lib/bugContext";

installConsoleCapture();

const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN && !isLocalhost,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(<App />);
